import { useDispatch, useSelector } from "react-redux";
import Loading from "./components/common/Loading";
import RouteIdentifier from "./routing/RouteIdentifier";
import routes from "./routing/router";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setLoadingContent, stopLoading } from "./redux/reducers/loadingSlice";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { loadingFromStore, text } = useSelector((state) => state.loading);

  useEffect(() => {
    dispatch(setLoadingContent([]));
    dispatch(stopLoading());
  }, [dispatch, location.pathname]);

  const showGlobalLoader =
    loadingFromStore || (Array.isArray(text) && text.length > 0);

  return (
    <>
      {showGlobalLoader && <Loading />}
      <RouteIdentifier routes={routes} />
    </>
  );
}

export default App;
